// import React from 'react';
import Navbar from '../new/Navbar';
import Sidebar from './Sidebar';

import React, { useState, useEffect, useRef } from 'react';
import { Transition } from '@headlessui/react';
import {
  MenuAlt2Icon,
  XIcon,
  HomeIcon,
  UserGroupIcon,
  ShoppingBagIcon,
  LogoutIcon,
} from '@heroicons/react/outline';
import {
  Lightbulb,
  Video,
  Mic,
  Brain,
  BarChart,
  BrainCircuit,
  ArrowRight,
} from 'lucide-react';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@headlessui/react';

import * as Dialog from '@radix-ui/react-dialog';

import {
  LayoutDashboard,
  MessageSquare,
  BarChart3,
  Settings,
  HelpCircle,
  Menu,
  Globe,
  ChevronLeft,
  ChevronRight,
} from 'lucide-react';

import { Link, useParams, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/context/AuthContext'; // Make sure to import useAuth
import useOwnerAuthCheck from '../auth/hooks/useOwnerAuthCheck';

import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 5000,
});

// Create a context for credits management
export const CreditsContext = React.createContext({
  credits: null,
  refreshCredits: () => {},
});

const Home = ({ children }) => {
  const location = useLocation();

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const [credits, setCredits] = useState(null);
  const { restaurantId } = useParams();
  const navigate = useNavigate();
  const { ownerLogout, isOwnerAuthenticated, ownerToken, ownerLogin } =
    useAuth(); // Add this line to get ownerLogout and ownerEmail

  const {
    isTokenValid,

    handleAuthenticatedAction,
  } = useOwnerAuthCheck();

  // Add resize handler
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        // md breakpoint
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const menuItems = [
    {
      icon: <LayoutDashboard className='w-5 h-5' />,

      title: 'Dashboard',
      path: `/restaurant/${restaurantId}`,
    },
    {
      icon: <LayoutDashboard className='w-5 h-5' />,

      title: 'Store Link',
      path: `/${restaurantId}`,
    },
    {
      icon: <MessageSquare className='w-5 h-5' />,
      title: 'Customers',
      path: `/restaurant/${restaurantId}/subscribers`,
    },
    {
      icon: <Settings className='w-5 h-5' />,
      title: 'Messages',
      path: `/restaurant/${restaurantId}/text-messages`,
    },
    {
      icon: <BarChart3 className='w-5 h-5' />,
      title: 'Send Message',
      path: `/restaurant/${restaurantId}/text-messages/new`,
    },
    {
      icon: <BarChart3 className='w-5 h-5' />,
      title: 'Coupons',
      path: `/restaurant/${restaurantId}/coupons`,
    },
    {
      icon: <BarChart3 className='w-5 h-5' />,
      title: 'Subscription QR Code',
      path: `/restaurant/${restaurantId}/qr-code`,
    },

    {
      icon: <BarChart3 className='w-5 h-5' />,
      title: 'Welcome Texts',
      path: `/restaurant/${restaurantId}/welcometext/view`,
    },
    {
      icon: <BarChart3 className='w-5 h-5' />,
      title: 'Set Welcome Text',
      path: `/restaurant/${restaurantId}/welcometext`,
    },
    {
      icon: <BarChart3 className='w-5 h-5' />,
      title: 'Stamps & Redeems',
      path: `/restaurant/${restaurantId}/reward/activity`,
    },
    // {
    //   icon: FaScroll,
    //   title: 'Stamp Paper Print',
    //   path: `/restaurant/${restaurantId}/checkin/paper`,
    // },
    {
      icon: <BarChart3 className='w-5 h-5' />,
      title: 'Set Stamp Rewards',
      path: `/restaurant/${restaurantId}/reward`,
    },
    // {
    //   icon: FaScroll,
    //   title: 'Reviews',
    //   path: `/restaurant/${restaurantId}/review`,
    // },
    // {
    //   icon: FaScroll,
    //   title: 'Set Review Coupon',
    //   path: `/restaurant/${restaurantId}/review/coupon`,
    // },
    // {
    //   icon: FaClipboardList,
    //   title: 'Membership',
    //   path: `/restaurant/${restaurantId}/membership`,
    // },
    {
      icon: <BarChart3 className='w-5 h-5' />,
      title: 'Opt-Out Text',
      path: `/restaurant/${restaurantId}/opt-out-word`,
    },
    {
      icon: <BarChart3 className='w-5 h-5' />,
      title: 'Restaurant Details',
      path: `/restaurant/${restaurantId}/details`,
    },
    {
      icon: <BarChart3 className='w-5 h-5' />,

      title: 'Main Dashboard',
      path: `/owner/dashboard`,
    },

    // { icon: FaSignOutAlt, title: 'Logout' },
  ];

  const handleLogout = () => {
    ownerLogout();
    navigate('/owner/login');
  };

  const fetchCredits = async () => {
    try {
      const token = localStorage.getItem('ownerToken');

      const response = await api.get('/credit/balance', {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(response.data);
      setCredits(response.data);
    } catch (error) {
      console.error('Error fetching credits:', error);
    }
  };

  useEffect(() => {
    fetchCredits();
  }, []);

  const creditsContextValue = {
    credits,
    refreshCredits: fetchCredits,
  };

  // const SidebarContent = ({ mobile = false }) => (
  //   <div className='flex flex-col h-full'>
  //     {/* Fixed header section */}
  //     <div className='p-6 flex items-center justify-between shrink-0'>
  //       <Link href='/'>
  //         <h1
  //           className={`font-bold whitespace-nowrap transition-all duration-300 overflow-hidden
  //           ${
  //             !isSidebarOpen && !mobile ? 'w-0 opacity-0' : 'w-auto opacity-100'
  //           }
  //           text-2xl flex items-center gap-2`}
  //         >
  //           <BrainCircuit className='w-8 h-8 text-primary' />
  //           <div className='flex flex-col'>
  //             <div className='flex items-center gap-1'>
  //               <span className='text-primary'>Interview</span>
  //               <span className='text-gray-600'>AI</span>
  //             </div>
  //             <span className='text-xs text-gray-500 -mt-1'>mock</span>
  //           </div>
  //         </h1>
  //       </Link>
  //       {!mobile && isSidebarOpen && (
  //         <button
  //           onClick={() => setIsSidebarOpen(false)}
  //           className='p-2 rounded-lg hover:bg-gray-100'
  //         >
  //           <ChevronLeft />
  //         </button>
  //       )}
  //       {mobile && (
  //         <button
  //           onClick={() => setIsMobileMenuOpen(false)}
  //           className='p-2 rounded-lg hover:bg-gray-100'
  //         >
  //           <XIcon className='w-6 h-6' />
  //         </button>
  //       )}
  //     </div>

  //     {/* Scrollable navigation section */}
  //     <nav className='flex-1 overflow-y-auto'>
  //       <ul className='space-y-1 px-4 pb-4'>
  //         {menuItems.map((item, index) => (
  //           <li key={item.href}>
  //             <Link
  //               key={index}
  //               to={item.path}
  //               className={`flex items-center justify-start
  //               gap-3 px-4 py-3 rounded-lg transition-colors
  //               ${
  //                 location.pathname === item.path
  //                   ? 'bg-primary text-white'
  //                   : 'hover:bg-gray-100'
  //               }
  //               ${!isSidebarOpen && !mobile ? 'hidden' : ''}`}
  //             >
  //               {React.cloneElement(item.icon, {
  //                 className: 'w-6 h-6',
  //               })}
  //               <span
  //                 className={`whitespace-nowrap transition-all duration-300 overflow-hidden
  //                 ${
  //                   !isSidebarOpen && !mobile
  //                     ? 'w-0 opacity-0'
  //                     : 'w-auto opacity-100'
  //                 }`}
  //               >
  //                 {item.title}
  //               </span>
  //             </Link>
  //           </li>
  //         ))}
  //       </ul>
  //     </nav>
  //   </div>
  // );

  const SidebarContent = ({ mobile = false }) => {
    const [showTopGradient, setShowTopGradient] = useState(false);
    const [showBottomGradient, setShowBottomGradient] = useState(false);
    const navRef = useRef(null);

    const handleScroll = () => {
      if (navRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = navRef.current;
        setShowTopGradient(scrollTop > 20);
        setShowBottomGradient(scrollTop + clientHeight < scrollHeight - 20);
      }
    };

    useEffect(() => {
      handleScroll();
    }, []);

    return (
      <div className='flex flex-col h-full'>
        {/* Fixed header section */}
        <div className='p-6 flex items-center justify-between shrink-0 relative z-10 bg-white'>
          <Link href='/'>
            <h1
              className={`font-bold whitespace-nowrap transition-all duration-300 overflow-hidden
              ${
                !isSidebarOpen && !mobile
                  ? 'w-0 opacity-0'
                  : 'w-auto opacity-100'
              }
              text-2xl flex items-center gap-2`}
            >
              <BrainCircuit className='w-8 h-8 text-primary' />
              <div className='flex flex-col'>
                <div className='flex items-center'>
                  <span className='text-primary'>Twi</span>
                  <span className='text-gray-600'>qli</span>
                </div>
                <span className='text-xs text-gray-500 -mt-1'>
                  Discover new places
                </span>
              </div>
            </h1>
          </Link>
          {!mobile && isSidebarOpen && (
            <button
              onClick={() => setIsSidebarOpen(false)}
              className='p-2 rounded-lg hover:bg-gray-100'
            >
              <ChevronLeft />
            </button>
          )}
          {mobile && (
            <button
              onClick={() => setIsMobileMenuOpen(false)}
              className='p-2 rounded-lg hover:bg-gray-100'
            >
              <XIcon className='w-6 h-6' />
            </button>
          )}
        </div>

        {/* Navigation container with gradients */}
        <div className='flex-1 relative min-h-0'>
          {/* Top gradient */}
          <div
            className={`absolute top-0 left-0 right-0 h-12 z-10 pointer-events-none
            bg-gradient-to-b from-white to-transparent
            transition-opacity duration-200
            ${showTopGradient ? 'opacity-100' : 'opacity-0'}`}
          />

          {/* Scrollable navigation */}
          <nav
            ref={navRef}
            onScroll={handleScroll}
            className='h-full overflow-y-auto relative'
          >
            <ul className='space-y-1 px-4 pb-4'>
              {menuItems.map((item, index) => (
                <li key={item.href}>
                  <Link
                    key={index}
                    to={item.path}
                    className={`flex items-center justify-start 
                    gap-3 px-4 py-3 rounded-lg transition-colors
                    ${
                      location.pathname === item.path
                        ? 'bg-primary text-white'
                        : 'hover:bg-gray-100'
                    }
                    ${!isSidebarOpen && !mobile ? 'hidden' : ''}`}
                  >
                    {React.cloneElement(item.icon, {
                      className: 'w-6 h-6',
                    })}
                    <span
                      className={`whitespace-nowrap transition-all duration-300 overflow-hidden
                      ${
                        !isSidebarOpen && !mobile
                          ? 'w-0 opacity-0'
                          : 'w-auto opacity-100'
                      }`}
                    >
                      {item.title}
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Bottom gradient */}
          <div
            className={`absolute bottom-0 left-0 right-0 h-12 z-10 pointer-events-none
            bg-gradient-to-t from-white to-transparent
            transition-opacity duration-200
            ${showBottomGradient ? 'opacity-100' : 'opacity-0'}`}
          />
        </div>
      </div>
    );
  };

  return (
    <CreditsContext.Provider value={creditsContextValue}>
      <div className='min-h-screen flex'>
        <aside
          className={`hidden md:block fixed top-0 left-0 h-screen border-r bg-white transition-all duration-300
        ${isSidebarOpen ? 'w-64' : 'w-0'}`}
        >
          <SidebarContent />
        </aside>

        <div
          className={`flex-1 transition-all duration-300 ${
            isSidebarOpen ? 'md:ml-64' : 'md:ml-0'
          }`}
        >
          <header className='h-16 border-b bg-white flex items-center justify-between px-4 sticky top-0 z-10'>
            {/* Left side - Menu buttons */}
            <div className='flex items-center'>
              {/* Mobile menu button */}
              <Dialog.Root
                open={isMobileMenuOpen}
                onOpenChange={setIsMobileMenuOpen}
              >
                <Dialog.Trigger asChild>
                  <button className='p-2 md:hidden'>
                    <Menu className='w-6 h-6' />
                  </button>
                </Dialog.Trigger>
                <Dialog.Portal>
                  <Dialog.Overlay className='fixed inset-0 bg-black/50 z-40' />
                  <Dialog.Content className='fixed top-0 left-0 h-full w-64 bg-white shadow-lg z-50'>
                    <SidebarContent mobile />
                  </Dialog.Content>
                </Dialog.Portal>
              </Dialog.Root>

              {/* Desktop menu button - only shows when sidebar is closed */}
              {!isSidebarOpen && (
                <button
                  onClick={() => setIsSidebarOpen(true)}
                  className='hidden md:block p-2'
                >
                  <Menu className='w-6 h-6' />
                </button>
              )}
            </div>

            {/* Right side - Credits and Logout */}
            <div className='flex items-center gap-2 sm:gap-4'>
              {/* Credits display with overflow protection */}
              <div className='flex items-center gap-2 min-w-0'>
                <span className='text-sm font-medium whitespace-nowrap'>
                  Credits:
                </span>
                <div className='px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm font-semibold max-w-[120px] truncate'>
                  {credits?.total ? credits.total : 0}
                </div>
              </div>

              {/* Logout button */}
              <button
                onClick={handleLogout}
                className='whitespace-nowrap text-white bg-indigo-600 px-3 py-1.5 text-sm rounded-lg hover:bg-indigo-700 transition duration-300'
              >
                Log Out
              </button>
            </div>
          </header>

          <main className='bg-gray-50 p-6 min-h-[calc(100vh-4rem)]'>
            {children}
          </main>
        </div>
        {/* </div> */}
      </div>
    </CreditsContext.Provider>
  );
};

export default Home;
